var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',{staticClass:"avatar-box",style:({backgroundImage: ("url(" + (_vm.user.avatar) + ")")}),attrs:{"role":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.showMenuSidebar.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }